// extracted by mini-css-extract-plugin
module.exports = {"root":"BaseVideo_root__D4U1s","video":"BaseVideo_video__bYtba","reveal-media":"BaseVideo_reveal-media__7uKhq"};